/* eslint-disable */
require('./icon-enterprise_service_management')
require('./icon-experience_design')
require('./icon-it_strategy_advisory')
require('./icon-programmes_projects')
require('./icon-software_apps')
require('./icon-solution_architecture')
require('./icon-systems_integration')
